import React, { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';
import { ACTION_IDS } from './constants';
import { RefundTournamentContent } from './components';

export const makeActionHandler = (actionId: string, params: any) => {
	const { ltid, mttid, cgrid, turnGlobalForceUpdateOn } = params;
	const { setModalConfig } = useContext(ModalContext);

	switch (actionId) {
		case ACTION_IDS.REFUND_TOURNAMENT:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Refund Tournament',
					content: (
						<RefundTournamentContent
							handleForceUpdate={turnGlobalForceUpdateOn}
							ltid={ltid}
							mttid={mttid}
							cgrid={cgrid}
						/>
					)
				});
			};

		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
